import React, {Component} from 'react';
// material
import SubPage from 'material/structure/subpage/subpage';
import Group from 'material/group/group';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import Link from 'material/ctas/link/link_container';
import Table from 'material/table/table';
// messages
import Notification from 'material/message/notification/notification';
//styles
// import injectSheet from 'react-jss';
// import styles from 'pages/dashboard/account/sites/sites_styles';



/* ========== ~~~~~~~~~~ PAGE : SITES : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Sites extends Component {

    handleRenderSites = () => {
        let sites =[];
        Object.keys(this.props.sites).forEach(item => sites.push({ name: <Link type={`external`} text={`${this.props.sites[item]}`} color={`primary`} action={`${this.props.sites[item]}`} /> }));
        return sites;
    };
    render() {
        return(
            <SubPage name={`sites`}>
                <Copy name={`page-copy`}>
                    <Title>
                        <h2>Sites</h2>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    <Notification variant={`neutral`} size={`full`} icon={`exclamation-triangle`} text={<span>If you want to add a site to your account, please email your Account Manager or email <Link type={`email`} text={`support@insticator.com`} color={`primary`} action={`mailto:support@insticator.com`} /></span>} />
                    { !!Object.keys(this.props.sites).length && <Table
                        name={`sites`}
                        type={`basic`} 
                        size={`full`}
                        columnHeads={{ name: 'Name' }}
                        data={this.handleRenderSites()}
                        rowsPerPage={'general'}
                        paginationLocation={`bottom`}
                    />}
                </Group>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Sites;
// export default injectSheet(styles)(Sites);